import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { CarouselTextItem as CarouselTextItemSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useContext } from 'react';

import { ElementLocation } from '../../context/ElementLocationContext/ElementLocationContext';
import { logUserEvent } from '../../helpers/logging';
import { UserAction } from '../../types/events';
import { renderRichText } from '../../utils/renderText/renderRichText';
import type { CarouselV3TextItemProps } from './types';

export const CarouselV3TextItem: FC<{
  textItem: CarouselV3TextItemProps;
}> = ({ textItem }) => {
  const description = renderRichText(textItem?.description);
  const subtext = renderRichText(textItem?.subtext);

  const slug = textItem.slugReference?.slug;
  const url = slug ? `/${slug}` : textItem.url;

  const elementLocation = useContext(ElementLocation).elementLocation;
  const elementText = textItem.description?.json
    ? documentToPlainTextString(textItem.description.json)
    : undefined;

  const onClick = (): void => {
    if (!url) {
      return;
    }

    logUserEvent({
      eventAction: UserAction.Click,
      eventCategory: 'CarouselV3',
      eventLabel: `CarouselV3.TextItem - ${url}`,
      context: {
        targetUrl: url,
        elementLocation,
        elementText,
      },
    });
  };

  return (
    <CarouselTextItemSDS
      key={textItem.sys.id}
      description={description}
      subText={subtext}
      url={url}
      onClick={onClick}
    />
  );
};

CarouselV3TextItem.displayName = 'CarouselV3TextItem';
